import React from 'react';
import {
    UsagePriceFont,
    UsagePricingDataContainer,
    Type,
} from './BundleCards.styled';
import TissueIcon from 'src/assets/images/TissueIcon.svg';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const QuantityContainer = ({
    quantity,
    isUsed,
    showLabel,
    uom,
    isShowUom,
    alignItems,
    orderType,
}) => {
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { t } = useTranslation();
    return (
        <>
            <UsagePricingDataContainer
                alignItems={alignItems}
                justifyContent={'flex-end'}
                margin={'0'}
            >
                {quantity || isUsed ? (
                    <>
                        {showLabel ? (
                            <UsagePriceFont
                                margin={'0 4px 0 0'}
                                color="#202124"
                                fontFamily="AvenirNextWorld Demi"
                            >
                                {orderType === 'KE'
                                    ? null
                                    : isUsed
                                    ? t(
                                          'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.used'
                                      )
                                    : t(
                                          'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.other'
                                      )}
                            </UsagePriceFont>
                        ) : null}

                        {countryISOCode === 'US' && orderType === 'KE' ? (
                            <img
                                style={{ marginRight: '5px' }}
                                src={TissueIcon}
                                alt="T"
                            />
                        ) : null}

                        <UsagePriceFont
                            fontSize="16px"
                            lineHeight="23px"
                            letterSpacing="-0.13px"
                            margin={'0 2px 0 0'}
                        >
                            {quantity ? quantity : null}
                            {isShowUom ? ' x' : null}
                        </UsagePriceFont>
                        {isShowUom || uom ? (
                            uom ? (
                                <Type>{uom}</Type>
                            ) : (
                                <Type>{t('consignmentReturn.submit.ea')}</Type>
                            )
                        ) : null}
                    </>
                ) : null}
            </UsagePricingDataContainer>
        </>
    );
};

export default QuantityContainer;
